import type {AgencyOverviewAction} from 'src/action-creators/agency-overview';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'AgencyOverview'. Did you mean to use 'import AgencyOverview from "src/api-parsers/index"' instead?
import type {AgencyOverview} from 'src/api-parsers/index';

import {
  RECEIVE,
  RECEIVE_ACTIVE_AUDIENCE,
} from 'src/action-creators/agency-overview';


export type AgencyOverviewState = {
  data: Record<any, any> | AgencyOverview; // TODO(marcos): fill this in;
  activeAudienceMembers: number | null | undefined;
};

const initialState = {
  data: {},
  activeAudienceMembers: null,
} as const;

export default (
  state: AgencyOverviewState = initialState,
  action: AgencyOverviewAction,
): AgencyOverviewState => {
  switch (action.type) {
    case RECEIVE:
      return {...state, data: action.payload};
    case RECEIVE_ACTIVE_AUDIENCE:
      // TODO (chris): Remove when multiEntityEnabled is deprecated
      return {
        ...state,
        activeAudienceMembers: action.payload,
      };
  }

  return state;
};
